import { db, FirebaseTimestamp } from "../../firebase";
import { push } from "connected-react-router";
import {
  fetchBoothsAction,
  deleteBoothAction,
  setBoothIdAction,
  initBoothIdAction,
  fetchSelectedBoothAction,
} from "./actions";

const boothsRef = db.collection("booths");

export const deleteBooth = (id, uid) => {
  return async (dispatch, getState) => {
    boothsRef
      .doc(id)
      .delete()
      .then(() => {
        const prevBooths = getState().booths.list;
        const nextBooths = prevBooths.filter((booth) => booth.id !== id);
        dispatch(deleteBoothAction(nextBooths));
      });
    dispatch(push("/organizer/" + uid));
  };
};

export const fetchBooths = () => {
  return async (dispatch) => {
    boothsRef
      .orderBy("updated_at", "desc")
      .get()
      .then((snapshots) => {
        const boothList = [];
        snapshots.forEach((snapshot) => {
          const booth = snapshot.data();
          boothList.push(booth);
        });
        dispatch(fetchBoothsAction(boothList));
      });
  };
};

export const fetchMyBooths = (currentUid) => {
  return async (dispatch) => {
    boothsRef.orderBy("updated_at", "desc");
    const query = boothsRef.where("uid", "==", currentUid);
    query.get().then((snapshots) => {
      const boothList = [];
      snapshots.forEach((snapshot) => {
        const booth = snapshot.data();
        boothList.push(booth);
      });
      dispatch(fetchBoothsAction(boothList));
    });
  };
};

export const fechSelectedBooth = (state) => {
  return async (dispatch) => {
    await boothsRef
      .doc(state)
      .get()
      .then((snapshot) => {
        const data = snapshot.data();
        dispatch(fetchSelectedBoothAction(data));
      });
  };
};

export const saveBooth = (
  id,
  uid,
  selectOpuses,
  boothName,
  description,
  organizerName,
  isBlack,
  isGothic,
  selectedDateBase,
  selectedDate,
  selectedTime,
  youtubeChannelId,
  youtubeApiKey,
  release,
  isCheer,
  cheerPrice
) => {
  return async (dispatch) => {
    const timestamp = FirebaseTimestamp.now();
    // const liveDay = selectedDate.toString();
    // const liveTime = selectedTime.toString();
    const data = {
      //左がFirestoreにフィールド名を指定、右が引数で受け取る値
      uid: uid,
      selectOpuses: selectOpuses,
      boothName: boothName,
      description: description,
      organizerName: organizerName,
      isBlack: isBlack,
      isGothic: isGothic,
      liveSchedule: selectedDateBase,
      liveDay: selectedDate,
      liveTime: selectedTime,
      youtubeChannelId: youtubeChannelId,
      youtubeApiKey: youtubeApiKey,
      release: release,
      isCheer: isCheer,
      cheerPrice: cheerPrice,
      updated_at: timestamp,
    };

    if (id === "") {
      const ref = boothsRef.doc();
      id = ref.id;
      data.id = id;
      data.created_at = timestamp;
    }
    return boothsRef
      .doc(id)
      .set(data, { merge: true })
      .then(() => {
        dispatch(push("/organizer/" + uid));
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

export const setBoothId = (boothId) => {
  return async (dispatch) => {
    dispatch(
      setBoothIdAction({
        boothId: boothId,
      })
    );
  };
};

export const initBoothId = () => {
  return async (dispatch) => {
    dispatch(initBoothIdAction());
  };
};
